<template>
	<div class="form-control">
    <label>{{  value.label }}</label>
    <input ref="input" v-model="value.value" type="text" v-on:input="updateTextFacet()">
  </div>
</template>

<script>
import _ from "lodash";

export default {
  props: ["value"],
  methods: {
    getUpdatedValueFromInput() {
      return _.assign({}, this.value, {
        value: this.$refs.input.value,
      });
    }
  },
  created () {
    this.updateTextFacet = _.debounce(function(){
      this.$emit("input", this.getUpdatedValueFromInput());
    }, 500);
  }

};
</script>

